module.exports = "pegasus/assets/finability-card.png";